<section class="comment-viewer-container">
	<cdk-virtual-scroll-viewport class="virtual-viewport" style="height: 100%;">
		<ul role="list" class="comment-list">
			<li
				role="listitem"
				*cdkVirtualFor="let comment of commentListService.comments$ | async; trackBy: 'comment_id'|trackByProp; templateCacheSize: 25;"
				[attr.data-comment-id]="comment.comment_id || comment.temp_id"
				data-cy="feedback-item"
				class="comment-item"
				[ngClass]="{
					'is-active': activeCommentIds.includes(comment.comment_id),
					'is-reply': comment.parent_id !== null,
					'end-note': comment.time === null,
					'is-selected': selectedComment?.comment_id === comment.comment_id,
					'unviewed': !comment.viewed_by_me
				}"
			>
				<span
					class="end-note-divider"
					*ngIf="comment.time === null && isFirstEndNote(comment) | async"
				></span>
				<button
					[tabindex]="editingCommentIds.includes(comment.comment_id) ? -1 : 0"
					class="comment-button"
					data-cy="feedback-item-cover"
					[attr.aria-label]="getAriaLabel(comment)"
					[disabled]="isTimeCodeClickDisabled()"
					(click)="onCommentClick(comment)"
				>
					<span
						*ngIf="shouldDisplayTimeCode(comment)"
						class="time-container"
						data-cy="feedback-badge"
						[tabindex]="editingCommentIds.includes(comment.comment_id) ? 0 : -1"
						(click)="
							editingCommentIds.includes(comment.comment_id)
								? editTime($event, comment)
								: null
						"
						(keyup.enter)="
							editingCommentIds.includes(comment.comment_id)
								? editTime($event, comment)
								: null
						"
						[matTooltip]="
							editingCommentIds.includes(comment.comment_id)
								? ('feedback-session-feedback-tree-comment_edit-time-code'
								  | translate)
								: ('time-code_disabled_video_seeking' | translate)
						"
						[matTooltipDisabled]="
							!editingCommentIds.includes(comment.comment_id) ||
							isTimeCodeClickDisabled()
						"
						[ngClass]="{
							editable: editingCommentIds.includes(comment.comment_id)
						}"
					>
						<span class="time-text">
							{{ comment.time | formatTime }}
						</span>
					</span>
					<span *ngIf="comment.parent_id !== null" class="reply-indicator">
						<i class="ficon-reply"></i>
					</span>
					<span class="comment-details">
						<span class="comment-header">
							<span class="commenter">
								<ng-container *ngIf="!isSyncEventType(comment); else syncEventType">
									{{ comment.first_name }} {{ comment.last_name }}
								</ng-container>
								<ng-template #syncEventType>
									<span class="ficon-app-presentation slide-deck-icon"></span><strong class="feedback-item-name" data-cy="feedback-item-name">{{('feedback-session-feedback-tree-comment_slide-time' | translate) + ' ' + comment.resource[0].item.time}}</strong>
								</ng-template>
							</span>
							<span
								*ngIf="!comment.viewed_by_me"
								[matTooltip]="(comment.directed_at_me ? 'feedback-item_directed-at-me' : 'feedback-item_unviewed') | translate"
								class="unviewed-dot"
								[ngClass]="{ 'not-directed-at-me': !comment.directed_at_me }">
							</span>
							<span class="comment-timestamp">
								{{ comment.created_at | formatDate: 'MMM D, YYYY h:mmA' }}
							</span>
						</span>
						<span
							*ngIf="
								comment.markers?.length > 0 &&
								!editingCommentIds.includes(comment.comment_id)
							"
						>
							<marker-display
								[markers]="comment.markers"
								[aiStyle]="comment.was_ai_generated"
								[withName]="true"
							>
							</marker-display>
						</span>
						<span
							*ngIf="!editingCommentIds.includes(comment.comment_id)"
							class="comment-text"
							data-cy="feedback-item-text"
							[innerHTML]="comment.text | sanitize"
						>
						</span>
						<span class="ai-edited-by" *ngIf="comment.updated_by" translate="feedback-session-feedback-tree-comment_ai-edited-by" [translateParams]="{ updated_by: comment.updated_by }"></span>
						<span
							*ngIf="
								comment.media?.length > 0 &&
								!editingCommentIds.includes(comment.comment_id)
							"
							class="all-media-container"
						>
							<div class="media-container" *ngFor="let media of comment.media; trackBy: 'media_id' | trackByProp">
								<div class="btn-bar media-item-toolbar" *ngIf="mayEdit(comment)" [ngClass]="{ 'visible': selectedComment?.comment_id === comment.comment_id }">
									<button
										type="button"
										(click)="setSelectedComment(comment, $event)"
										[matMenuTriggerFor]="mediaMenu"
										class="btn-none menu-btn media-menu-btn"
										[attr.aria-label]="'session-list-item_view-options' | translate"
									>
										<i class="ficon-app-dots-vertical"></i>
									</button>

									<mat-menu #mediaMenu="matMenu" class="action-menu">
										<button
											mat-menu-item
											class="remove-btn"
											(click)="deleteMediaResource(comment, media.item)"
										>
											{{ "common_delete" | translate }}
										</button>
										<button
											mat-menu-item
											class="download-btn"
											*ngIf="media.item.filename && media.item.media_status === 'ready'"
											(click)="download($event, media.item)"
										>
											{{ "common_download" | translate }}
										</button>
									</mat-menu>
								</div>
								<media-preview
									(click)="$event.stopPropagation()"
									class="media-item-preview"
									[ngClass]="{ audio: media.item.media_type === 'audio' }"
									[media]="media.item"
									[previewerId]="
										'comment-media-' + media.comment_id + '-' + media.resource_id
									"
									[initialOffset]="media.item.time"
									[collapseAudio]="media.item.media_type === 'audio'"
									[minimizedControls]="true"
									[allowDownload]="media.item.filename"
									[options]="mediaPreviewOptions"
								>
								</media-preview>
								<span class="media-item-title" *ngIf="media.item.title">{{
									media.item.title
								}}</span>
							</div>
						</span>
						<ngx-comment-reactions
							*ngIf="
								comment.reactions?.length &&
								!editingCommentIds.includes(comment.comment_id)
							"
							class="display-mode"
							[mode]="commentReactionModes.DISPLAY"
							[comment]="comment"
						>
						</ngx-comment-reactions>
					</span>
				</button>

				<ngx-comment-menu
					*ngIf="!ltiReadOnly"
					class="visible-when-active"
					(setSelectedComment)="setSelectedComment(comment)"
					[mode]="commentReactionModes.DISPLAY"
					[feedbackItem]="comment"
					[hideCommentReply]="hideCommentReply"
					(edit)="edit($event)"
				>
				</ngx-comment-menu>

				<feedback-time-editor
					*ngIf="editingCommentTime.includes(comment.comment_id)"
					[duration]="totalDuration"
					[comment]="comment"
					(onSave)="keepTimeEdit($event, comment)"
					(onClose)="cancelTimeEdit(comment)"
				>
				</feedback-time-editor>

				<span class="slide-preview-container" *ngIf="editingCommentIds.includes(comment.comment_id) && isSyncEventType(comment)">
					<media-preview
						class="slide-preview"
						[media]="session.source_media"
						[previewerId]="'comment-media-' + comment.comment_id + '-' + comment.resource[0].resource_id"
						[initialOffset]="comment.resource[0].item.time"
						[options]="mediaPreviewOptions">
					</media-preview>
				</span>

				<ngx-feedback-creator
					*ngIf="showFeedbackCreator(comment)"
					[session]="session"
					[playerSync]="playerSync"
					[tagsList]="tags"
					[userGroup]="group"
					[oldComment]="comment"
					[mode]="'edit'"
					[viewFrom]="viewFrom"
					(onClose)="cancelEdit(comment)"
				></ngx-feedback-creator>
			</li>
		</ul>
	</cdk-virtual-scroll-viewport>
</section>
